import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import defaultAvatar from '../assets/smart_mentor.png';
import { HiOutlineBars3CenterLeft } from "react-icons/hi2";

const Navbar = ({ onToggleSidebar }) => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')) || null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef();

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/';
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <nav className="sticky top-0 z-30 flex items-center justify-between px-4 sm:px-6 py-2.5 mx-4 sm:mx-6 mb-4 mt-4 sm:mt-4 rounded-xl shadow-md bg-white/80 backdrop-blur-md border border-gray-100/50">
      <div className="flex items-center">
        <button
          onClick={onToggleSidebar}
          className="lg:hidden p-2 mr-2 rounded-lg hover:bg-gray-100 transition-colors"
        >
          <HiOutlineBars3CenterLeft size={24} className="text-gray-600" />
        </button>
        <h4 className="text-sm sm:text-lg font-semibold truncate max-w-[150px] sm:max-w-none text-gray-800">
          Welcome back, {user?.first_name || "User"}! 👋
        </h4>
      </div>

      <div className="flex items-center space-x-3">
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="flex items-center focus:outline-none"
          >
            <div className="relative">
              <img
                src={user?.dp || defaultAvatar}
                alt="Profile"
                className="w-10 h-10 rounded-full object-cover border-2 border-indigo-600 ring-2 ring-indigo-600/20 shadow-inner"
              />
              <span className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-white rounded-full"></span>
            </div>
          </button>

          {dropdownOpen && (
            <div className="absolute right-0 mt-3 w-48 rounded-lg shadow-xl py-1 z-50 border bg-white border-gray-100 text-gray-700">
              <div className="px-4 py-3 border-b border-gray-100">
                <p className="text-sm font-semibold">{user?.first_name} {user?.last_name}</p>
                <p className="text-xs text-gray-400 truncate">{user?.email}</p>
              </div>
              <Link
                to="/profile"
                className="block px-4 py-2 text-sm transition-colors duration-200 hover:bg-indigo-50 hover:text-indigo-600"
                onClick={() => setDropdownOpen(false)}
              >
                My Profile
              </Link>
              <button
                onClick={handleLogout}
                className="w-full text-left px-4 py-2 text-sm transition-colors duration-200 hover:bg-indigo-50 hover:text-indigo-600"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
